const ImagesRoute = {
  myImg: require("./images/myImg.png"),
  SSlog: require("./images/SSlog.png"),
  NNlog: require("./images/NNlog.png"),
  IMG_6728: require("./images/IMG_6728.jpg"),
  IMG_3975: require("./images/IMG_3975.jpg"),
  IMG_6732: require("./images/IMG_6732.jpg"),
  IMG_1782: require("./images/IMG_1782.jpg"),
  so: require("./images/so.png"),
  so1: require("./images/so1.png"),
  yuragi: require("./images/yurgi.png"),
  react_ico: require("./images/react_ico.png"),
  go_ico: require("./images/go_ico.png"),
  NET_icon: require("./images/NET_icon.png"),
  gp83: require("./images/gp83.png"),
  manaphoto: require("./images/manaphoto.png"),
  IMG_5658: require("./images/IMG_5658.jpeg"),
  haryhi1: require("./images/haryhi1.jpeg"),
  haruhi2: require("./images/haruhi2.jpeg"),
  IMG_2839: require("./images/IMG_2839.jpg"),
  IMG_1347: require("./images/IMG_1347.jpg"),
  IMG_2122: require("./images/IMG_2122.jpg"),
  IMG_152: require("./images/IMG_152.jpg"),
  scs: require("./images/scs.png"),
  outfitw: require("./images/outfitw.png"),
  manamisky: require("./images/manamisky.jpg"),
  dawn: require("./images/dawn.png"),
  outfitgamen: require("./images/outfitgamen.png"),
  manamisorami1: require("./images/manamisorami1.jpg"),
  outfitmain: require("./images/outfitmain.png"),
  manamisorami2: require("./images/manamisorami2.jpg"),
  Blender_23505: require("./images/Blender_23505.png"),
  file_type_python_icon_130221: require("./images/file_type_python_icon_130221.png"),
  laravel_icon: require("./images/laravel_icon.png"),
  S__111206405: require("./images/S__111206405.jpg"),
  dawn_cat: require("./images/dawn_cat.png"),
  dawn_cat_ani: require("./images/dawn_cat_ani.png"),
  dawn_cat_ani2: require("./images/dawn_cat_ani2.png"),
  MePhoto: require("./images/MePhoto.jpg"),
  MePhoto2: require("./images/MePhoto2.jpg"),
  code: require("./images/code.png"),
  design: require("./images/design.png"),
  photo: require("./images/photo.png"),
  openButton: require("./images/openButton.png"),
  matitaka_wh: require("./images/matitaka-wh.png"),
  manami_hydoro: require("./images/manami_hydoro.png"),
  IMG144: require("./images/IMG144.jpg"),
  IMG145: require("./images/IMG145.jpg"),
  IMG147: require("./images/IMG147.jpg"),
  arrow: require("./images/arrow.png"),
  IMG_1417: require("./images/IMG_1417.jpg"),

  netmaui: require("./images/.netmaui.png"),
  csharp: require("./images/cs.png"),
  cpp: require("./images/cpp.png"),
  css: require("./images/css.png"),
  go: require("./images/go.png"),
  html: require("./images/html.png"),
  java: require("./images/java.png"),
  js: require("./images/js.png"),
  laravel: require("./images/laravel.png"),
  mysql: require("./images/mysql.png"),
  php: require("./images/php.png"),
  python: require("./images/python.png"),
  react: require("./images/react.png"),
  ubuntu: require("./images/ubuntu.png"),
  xaml: require("./images/xaml.png"),
  xml: require("./images/xml.png"),
  tailwind: require("./images/tailwind.png"),
  node: require("./images/node.png"),
  arduino: require("./images/arduino.png"),
  me: require("./images/me.jpg"),

  logis_icon: require("./images/Logis_icon.png"),
  logis_ap: require("./images/logis_ap.png"),
  logis_sc1: require("./images/logis-sc1.png"),
  logis_sc2: require("./images/logis-sc2.png"),
  logis_sc3: require("./images/logis-sc3.png"),
  table_5356682_1920: require("./images/table-5356682_1920.jpg"),
  chronodawn_log: require("./images/chronodawn_log.png"),

  //material
  i1516528960: require("./images/materials/1516528960.png"),
  net_icno: require("./images/materials/net_icon.png"),
  server_icon: require("./images/materials/server_icon.png"),
  ckeck: require("./images/materials/ckeck.png"),
  mainasu: require("./images/materials/mainasu.png"),
  tilekku: require("./images/materials/tilekku.png"),
  gan: require("./images/materials/9.jpg"),
  content1: require("./images/materials/content1.png"),
  content2: require("./images/materials/content2.png"),
  framer_logo: require("./images/materials/framer_logo_icon_169149.png"),
  adobefonts: require("./images/materials/adobefonts.png"),
  core: require("./images/materials/core.png"),
  xd: require("./images/materials/xd.png"),
  lightroom: require("./images/materials/lightroom.png"),
  photoshop: require("./images/materials/photoshop.png"),
  excel: require("./images/materials/excel.png"),
  fonts: require("./images/materials/adobefonts.png"),
  adobeexpress: require("./images/materials/adobeexpress.png"),
  IMG_7009: require("./images/IMG_7009-Enhanced-NR.jpg"),
  IMG_7017: require("./images/IMG_7017.jpg"),
  IMG_7018: require("./images/IMG_7018.jpg"),
};

export default ImagesRoute;
